import React, { useState } from "react";
import { Mail, Send } from "lucide-react";
import Layout from "@/components/Layout";
import { OPERATOR, operatorBankLine } from "@/lib/operator";

export default function ContactPage() {
  const [sent, setSent] = useState(false);
  return (
    <Layout>
      <div className="grid md:grid-cols-2 gap-6 max-w-4xl">
        <div className="stb-card p-6">
          <h1 className="stb-h text-3xl text-white">Kontakt</h1>
          <hr className="stb-divider" />
          <h2 className="stb-h text-lg text-[#FF6B00]">Provozovatel</h2>
          <p className="text-[#E5E5E5] mt-2">
            <strong>{OPERATOR.company}</strong><br />
            Sídlo: {OPERATOR.address}<br />
            IČO: {OPERATOR.icPretty}<br />
            Neplátce DPH<br />
            Zápis: {OPERATOR.registry}<br />
            {operatorBankLine()}
          </p>

          <h2 className="stb-h text-lg text-[#FF6B00] mt-4">E-mail</h2>
          <a href={`mailto:${OPERATOR.email}`} className="stb-link inline-flex items-center gap-2 mt-1">
            <Mail size={14} /> {OPERATOR.email}
          </a>

          <h2 className="stb-h text-lg text-[#FF6B00] mt-4">Partner</h2>
          <p className="text-[#E5E5E5] mt-1">
            Portál pro řemeslníky:{" "}
            <a
              href="https://www.craftbolt.cz"
              target="_blank"
              rel="noopener noreferrer"
              className="stb-link"
            >
              www.craftbolt.cz
            </a>
          </p>
        </div>

        <form
          className="stb-card p-6"
          onSubmit={(e) => {
            e.preventDefault();
            setSent(true);
          }}
          data-testid="contact-form"
        >
          <h2 className="stb-h text-2xl text-white">Napište nám</h2>
          <p className="stb-label mt-1">Otázky, podněty, problémy s inzerátem.</p>
          {sent ? (
            <div className="mt-4 stb-card border-[#22C55E] p-3" data-testid="contact-form-success">
              <p className="stb-h text-[#22C55E]">Děkujeme, ozveme se brzy.</p>
            </div>
          ) : (
            <div className="mt-4 space-y-3">
              <input className="stb-input" placeholder="Jméno" required />
              <input className="stb-input" placeholder="E-mail" type="email" required />
              <textarea className="stb-input" placeholder="Zpráva" required />
              <button className="stb-btn stb-btn-primary w-full">
                <Send size={14} /> Odeslat
              </button>
              <p className="stb-label">Formulář je v MVP. Reálné odesílání bude přidáno s Resend.</p>
            </div>
          )}
        </form>
      </div>
    </Layout>
  );
}
